import React, { useId, useState } from 'react';
import Image from 'next/image';

import {
  TextInputWrapper,
  InputLabel,
  Input,
  ErrorMessage,
  IconWrapper
} from '../TextInput/style';

import { BaseInputProps, TextInputWidth } from '../shared';

import icon from '@/images/error_icon.svg';

interface DateProps extends BaseInputProps {
  borderColor?: string;
  handleOnChange: (event: React.ChangeEvent, value: string) => void;
}

export function Date({
  type,
  value,
  label,
  placeholder,
  error,
  required,
  handleOnChange,
  disabled = false,
  width = TextInputWidth.FULL,
  borderColor = '#00C9A7',
  pattern
}: DateProps) {
  const [isFocused] = useState<boolean>(true);
  const inputId = useId();

  return (
    <>
      <TextInputWrapper width={width} error={!!error} borderColor={borderColor}>
        <InputLabel htmlFor={inputId} floatLabel={!!value || isFocused}>
          {label}
          {required ? '*' : ''}
        </InputLabel>
        <Input
          id={inputId}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          floatLabel={!!value || isFocused}
          pattern={pattern}
          onChange={(e) => {
            if (handleOnChange) handleOnChange(e, e.currentTarget.value);
          }}
          aria-required={required}
          aria-invalid={!!error}
          data-testid={`input-date-${label}`}
        />
      </TextInputWrapper>
      <ErrorMessage data-testid={`input-date-${label}-error`} visible={!!error}>
        <IconWrapper>
          <Image src={icon} alt="error icon" />
        </IconWrapper>
        {error || ''}
      </ErrorMessage>
    </>
  );
}
